export class AuwBaseComponent{


    constructor($el){
        this.$el=$el;
        //this.$el.data("auw_instance",this);
        this.config = {};
        setTimeout(this.mergeConfigWithDataAttributes.bind(this));
        $(document).ready(() => this.__PageReady());

        $(window).on('load', () => this.__WindowLoad());
    }

    mergeConfigWithDataAttributes(){
        if(this.$el) {
            $.extend(this.config, this.$el.data());
            $.each(this.$el.data(), (name, value) => {
                name = name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
                this.$el.removeAttr("data-" + name);
            });
        }
    }

    __PageReady(){}

    __WindowLoad(){}

    createCookie(name,value,ttl) {
        var date = new Date();
        date.setTime(date.getTime()+(ttl*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();

        document.cookie = name+"="+value+expires+"; path=/";
    }

    readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    eraseCookie(name) {
        this.createCookie(name,"",-1);
    }
}
